import { execAdmin } from '../utils';

interface GetCatalogUploadsVariables {
  partnerId: number;
  page?: number;
  pageSize?: number;
}

export interface CatalogUploadData {
  uploadType?: string;
  scheduledAt?: string;
  timezone?: string;
  added?: number;
  updated?: number;
  skipped?: number;
  errored?: number;
  unchanged?: number;
  errorCount?: number;
  successCount?: number;
  totalRowCount?: number;
}

export interface CatalogUploadListItem {
  id: number;
  title: string | null;
  source: string | null;
  sourcePartner: string | null;
  uploadStatus: string | null;
  date: string | null;
  initiatedBy: string | null;
  totalRecords: number | null;
  hasOriginalFile: boolean | null;
  data: CatalogUploadData | null;
}

export interface GetCatalogUploadsResponse {
  catalogUploads: {
    count: number;
    page: number;
    pageSize: number;
    rows: CatalogUploadListItem[];
  };
}

const CATALOG_UPLOADS_QUERY = `
  query catalogUploads(
    $partnerId: Int
    $page: Int
    $pageSize: Int
  ) {
    catalogUploads(
      partnerId: $partnerId
      page: $page
      pageSize: $pageSize
    ) {
      count
      page
      pageSize
      rows {
        id
        title
        source
        sourcePartner
        uploadStatus
        date
        initiatedBy
        totalRecords
        hasOriginalFile
        data
      }
    }
  }
`;

export const getCatalogUploads = async (
  partnerId: number,
  page = 1,
  pageSize = 25,
): Promise<GetCatalogUploadsResponse> => {
  return execAdmin<GetCatalogUploadsVariables, GetCatalogUploadsResponse>(
    CATALOG_UPLOADS_QUERY,
    { variables: { partnerId, page, pageSize } },
  );
};
